import {Component, OnInit} from '@angular/core';
import {CommonComponent} from '../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../services/notifications.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ERequestType} from '../../enums/ERequestType';
import {ApplicationService} from '../../services/application.service';
import {ToastaService} from 'ngx-toasta';
import {mergeMap} from 'rxjs/operators';
// import {errorObject} from 'rxjs/internal-compatibility';
import {TranslateService} from '@ngx-translate/core';
import {DialogService} from "primeng/dynamicdialog";
import {LocalStorageService} from "angular-2-local-storage";
import {StorageItem} from "../../enums/storage-item";

@Component({
  selector: 'app-cancel-request',
  templateUrl: './cancel-request.component.html',
  styleUrls: ['./cancel-request.component.scss'],
  providers: [ApplicationService]
})
export class CancelRequestComponent extends CommonComponent implements OnInit {
  cancelToken: string = null;
  cancelType: ERequestType = null;
  type: string = null;
  cancelled = false;
  button = true;
  locale = this.route.snapshot.queryParamMap.get('locale');

  constructor(
    private route: ActivatedRoute,
    private applicationService: ApplicationService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private localStorage: LocalStorageService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    translate.addLangs(['es', 'en']);
    translate.setDefaultLang('es');
    if (this.locale === 'es' || this.locale === 'en'){
      translate.use(this.getValidLanguage(this.locale));
    }
  }

  ngOnInit(): void {
    this.route.params.pipe(
      mergeMap((response: any) => {
        this.cancelToken = response.token ? response.token : null;
        return this.route.queryParams;
      }),
    ).subscribe(
      (response: any) => {
        this.cancelType = response.type ? response.type : null;
        switch (this.cancelType) {
          case ERequestType.EMAIL:
            this.type = 'Correo electrónico';
            break;
          case ERequestType.PHONE:
            this.type = 'Celular';
            break;
          default:
            this.button = false;
            // this.msgError(errorObject);
        }
      }, error => {
        this.msgError(error);
      }
    );
  }

  cancelRequest() {
    this.loadingModalOn();
    this.applicationService.cancelRequest(this.cancelToken, this.cancelType).subscribe(
      (response: any) => {
        this.cancelled = true;
        this.loadingModalOff();
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
      }
    );
  }

}
